import { Attributes, List, Misc, Rules, Validation } from '@singularsystems/neo-core';
import { DayOfMonthType } from './DayOfMonthType.enum';
import { DateCycleType } from './DateCycleType';
import DateCycleDate from './DateCycleDate';
import TemporalEntity from '../TemporalEntity';

export default class DateCycle extends TemporalEntity {
    static typeName = "DateCycle";

    constructor() {
        super();
        this.makeObservable();
    }

    public dateCycleId: number = 0;

    @Rules.Required()
    @Rules.StringLength(50)
    public dateCycleName: string = "";

    @Rules.StringLength(200)
    public description: string = "";

    public dateCycleType: DateCycleType = DateCycleType.Any;

    public forSingleInvestment: boolean = false;

    public dayOfMonthType: DayOfMonthType | null = null;

    @Attributes.Integer()
    public ordinal: number = 99;

    public dates = new List(DateCycleDate);

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public isLinkedToInvestments: boolean | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public isExpanded = false;

    protected static addBusinessRules(rules: Validation.Rules<DateCycle>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.dates.length === 0, "Date cycle must have at least one date.");
    }

    public toString(): string {
        if (this.isNew || !this.dateCycleName) {
            return "New date cycle";
        } else {
            return this.dateCycleName;
        }
    }
}